var deviceWidth = document.documentElement.clientWidth
if (deviceWidth > 400) deviceWidth = 400
document.documentElement.style.fontSize = deviceWidth / 7.5 + 'px'



// WEBPACK FOOTER //
// ./src/util/rem.js